import { useContext, useEffect } from 'react';
import usePrevious from './usePrevious';
import { TabContext } from '../context';
import { isBoolean } from 'lodash-es';


/**
 * tab 切换时回调，tab 首次渲染不会触发
 * @param callback
 */
export default function useTabShowCallback(callback: Function) {
  const { active } = useContext(TabContext);
  const prevActive = usePrevious(active);

  useEffect(() => {
    if (active && isBoolean(prevActive) && !prevActive) {
      callback();
    }
  }, [active, prevActive]);
}
